/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ICommand } from '../ICommand';
import { Document } from '../../core/models/Document';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class OtCommand {
    public author : string;

    public contentVersion : number;

    public command : ICommand;

    public local : boolean;

    public reverted : boolean;

    /**
     * Executes the command against the given document.  Skips execution if the command
     * has been reverted/undone.
     * @param {Document} document
     */
    public execute(document : Document) {
        if(!this.reverted) {
            this.command.execute(document);
        }
    }

    /**
     * Invokes 'undo' on the underlying ICommand but only if it hasn't already been reverted.
     * Any command already reverted will simply be skipped.
     * @param {Document} document
     */
    public undo(document : Document) {
        if(this.reverted) {
        } else {
            this.command.undo(document);
            this.reverted = true;
        }
    }

    /**
     * Invokes 'redo' on the underlying ICommand but only if it hasn't already been reverted.
     * Any command already reverted will simply be skipped.
     * @param {Document} document
     */
    public redo(document : Document) {
        if(!this.reverted) {
        } else {
            this.command.execute(document);
            this.reverted = false;
        }
    }

    constructor() {
        if(this.author===undefined) this.author = null;
        if(this.contentVersion===undefined) this.contentVersion = 0;
        if(this.command===undefined) this.command = null;
        if(this.local===undefined) this.local = false;
        if(this.reverted===undefined) this.reverted = false;
    }
}
OtCommand["__class"] = "io.apicurio.datamodels.cmd.ot.OtCommand";



